import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'alarmType'
})
export class AlarmTypePipe implements PipeTransform {

  transform(type: number, args?: any): String {
    switch(type) {
      case 1: {
        return 'Site offline';
      }
      case 2: {
        return 'Site discovered';
      }
      case 3: {
        return 'Site mode changed';
      }
      case 21: {
        return 'Device mode changed';
      }
      case 22: {
        return 'Device removed';
      }
      case 23: {
        return 'Device offline';
      }
      case 24: {
        return 'Device discovered';
      }
      case 41: {
        return 'Port mode changed';
      }
      case 42: {
        return 'Port state changed';
      }
      default: {
        return 'Unknown';
      }
    }
  }

}
